import React from 'react';

export const PayTypeHeaderCell: React.FC = () => (
    <span title="Pay Type">
        PT
    </span>
);
